import { Link } from "react-router-dom";
import type { SectionProps } from "../types";

interface CTASectionProps extends SectionProps {
  phone?: string;
}

const trustBadges = [
  { icon: "ri-shield-check-line", text: "Cam kết chất lượng" },
  { icon: "ri-refund-line", text: "Học lại miễn phí" },
  { icon: "ri-customer-service-2-line", text: "Hỗ trợ trọn đời" },
];

export default function CTASection({
  isVisible,
  sectionRef,
  phone = "1900-xxxx",
}: CTASectionProps) {
  return (
    <section
      ref={sectionRef}
      data-section="cta"
      className="py-16 sm:py-20 md:py-24 lg:py-32 bg-gradient-to-br from-[#2a4b7c] to-[#1e3a5f] relative overflow-hidden"
    >
      {/* Background decorations */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-1/2 left-1/4 w-64 h-64 sm:w-96 sm:h-96 bg-cyan-400 rounded-full blur-3xl animate-pulse"></div>
        <div
          className="absolute top-1/2 right-1/4 w-64 h-64 sm:w-96 sm:h-96 bg-cyan-400 rounded-full blur-3xl animate-pulse"
          style={{ animationDelay: "1s" }}
        ></div>
      </div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 text-center relative z-10">
        <div
          className={`transition-all duration-1000 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"
          }`}
        >
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-black text-white mb-4 sm:mb-6 leading-tight px-4">
            Bắt Đầu Hành Trình Trở Thành
            <br />
            <span className="bg-gradient-to-r from-cyan-400 via-blue-400 to-cyan-400 bg-clip-text text-transparent bg-[length:200%_auto] animate-text-shimmer">
              Kỹ Sư Công Nghệ Ngay Hôm Nay
            </span>
          </h2>
          <p className="text-sm sm:text-base md:text-lg lg:text-xl xl:text-2xl text-gray-300 mb-8 sm:mb-10 md:mb-12 leading-relaxed max-w-3xl mx-auto px-4">
            Đầu tư cho bản thân là khoản đầu tư sinh lời nhất.
            <br className="hidden sm:block" />
            <span className="sm:inline"> </span>Hãy để chúng tôi đồng hành cùng bạn trên con đường chinh phục công
            nghệ.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center mb-8 sm:mb-10 md:mb-12 px-4">
            <Link
              to="/lien-he"
              className="w-full sm:w-auto px-8 sm:px-10 md:px-12 py-3.5 sm:py-4 md:py-5 bg-cyan-500 text-white text-sm sm:text-base md:text-lg font-bold rounded-lg hover:bg-cyan-400 transition-all duration-300 hover:scale-105 hover:shadow-2xl shadow-xl shadow-cyan-500/40"
            >
              Đăng ký tư vấn miễn phí
            </Link>
            <a
              href={`tel:${phone}`}
              className="w-full sm:w-auto px-8 sm:px-10 md:px-12 py-3.5 sm:py-4 md:py-5 border-2 border-white text-white text-sm sm:text-base md:text-lg font-bold rounded-lg hover:bg-white hover:text-[#2a4b7c] transition-all duration-300 hover:scale-105 backdrop-blur-sm flex items-center justify-center gap-2"
            >
              <i className="ri-phone-line"></i>
              Gọi ngay: {phone}
            </a>
          </div>

          {/* Trust Badges */}
          <div className="grid grid-cols-3 gap-4 sm:gap-6 md:gap-8 max-w-3xl mx-auto pt-8 sm:pt-10 md:pt-12 border-t border-white/20 px-4">
            {trustBadges.map((badge, index) => (
              <div key={index} className="text-center">
                <i className={`${badge.icon} text-2xl sm:text-3xl md:text-4xl text-cyan-400 mb-2 sm:mb-3 block`}></i>
                <div className="text-white font-semibold text-xs sm:text-sm md:text-base">{badge.text}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

